import React, { Component } from "react";
import { Helmet } from "react-helmet";
import AuthorProfileApprovalsView from "./view/author-profile-approvals.jsx";

class AuthorProfileApprovalsPage extends Component {
  render() {
    return (
      <div>
        <Helmet title="Author Profile Approvals | PubNinja - You Publish. The rest we manage." />
        <AuthorProfileApprovalsView />
      </div>
    );
  }
}

export default AuthorProfileApprovalsPage;
